const pushToDataLayer = args =>
  new Promise((resolve, reject) => {
    const resolvePushToDataLayer = async () => {
      try {
        const result = window.asos.siteChrome.pushToDataLayer(args);
        resolve(result);
      } catch (e) {
        reject(e);
      }
    };

    if (window.asos.siteChrome.pushToDataLayer) {
      resolvePushToDataLayer();
    } else {
      window.asos.eventBus.once("pushToDataLayer-ready", () => {
        resolvePushToDataLayer();
      });
    }
  });

export default pushToDataLayer;
